import React from "react";

const Input = ({ className, ...props }) => {
  return (
    <input
      className={`border border-gray-300 px-4 py-2 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:outline-none transition ${className}`}
      {...props}
    />
  );
};

export default Input;
